import { MouseEvent } from 'react';
import * as styles from './styles';

interface IHamburgerMenuIcon {
  onClick?: (e: MouseEvent<any>) => void;
  open?: boolean;
}

export const HamburgerMenuIcon = ({ open, onClick, ...otherProps }: IHamburgerMenuIcon) => (
  <styles.Wrapper onClick={onClick} {...otherProps}>
    <styles.Inner>
      <styles.Line1 open={open} />
      <styles.Line2 open={open} />
      <styles.Line3 open={open} />
      <styles.Line4 open={open} />
    </styles.Inner>
  </styles.Wrapper>
);

HamburgerMenuIcon.displayName = 'HamburgerMenuIcon';
